import { Link } from "react-router-dom";

export const MyBubblyLink = ({ to = "", text = "" }) => (
  <Link to={to}>
    <button type="button" class={`react-bubbly-transitions__bubbly-link ${window.location.pathname === to ? "active" : ""}`}>
      {text}
    </button>
  </Link>
);
